export const EVENT_SOURCE_ID_TICKET_BIZ = '4001';

/**
 * Method to Check if the Event is from the Ticket Biz catalog.
 * @param event [object={}] The Instance of the Event Object got from the Search Catalog Events API.
 * @returns boolean [boolean] The flag indicating if the event is from ticketbiz catalog.
 * @TODO - This Method is used in the `react-event-redirection` and have to replaced there
 *
 */
export default (event = {}) => {
  const sourceId = event.attributes ? event.attributes.sourceId : event.sourceId;

  return sourceId === EVENT_SOURCE_ID_TICKET_BIZ;
};
